import { render, staticRenderFns } from "./HeaderMobile.vue?vue&type=template&id=0c06e798&scoped=true"
import script from "./HeaderMobile.vue?vue&type=script&lang=js"
export * from "./HeaderMobile.vue?vue&type=script&lang=js"
import style0 from "./HeaderMobile.vue?vue&type=style&index=0&id=0c06e798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06e798",
  null
  
)

export default component.exports